<template lang="pug">
  j-dialog-container(
    ref="dialog_container"
    :label="label"
    :mode="isAdd ? 'create' : 'update'"
    :loading="loading"
    :is-on-mobile="isOnMobile"
    :height= "height ?? 'auto'"
    :width= "width"
    @on-close="closeDialog"
    @on-update="updateGroup"
    @on-create="createGroup"
    v-model="show"
    :showBottom="!isDisabled"
  )
    validation-observer(
      ref="observer"
      v-slot="{ invalid }"
    )
      slot(name="content" :isDisabled="isDisabled")
        slot(name="top" :isDisabled="isDisabled")
        slot(name="after-top")
        validation-provider(v-if="!hideFields.includes('code')" :name="$t('common.code')" :rules="{ required: true, numeric_code_rule: true }" v-slot="{ errors }")
          v-text-field#code(
            :autofocus="isAutofocus"
            v-next-focus
            hide-spin-buttons
            :error-messages="errors"
            :value="masterData.code"
            @input="onCodeInput"
            :label="$t('common.code')"
            :disabled="isDisabled"
          )
            template(v-slot:label)
              span {{$t("common.code")}}
              span.red--text *
        slot(name="name" :master-data="masterData")
          validation-provider(v-if="!hideFields.includes('name')" rules="required" v-slot="{ errors }" :name="$t('common.name')")
            v-text-field#name(
              v-next-focus
              :error-messages="errors"
              v-model="masterData.name"
              :disabled="isDisabled"
            )
              template(v-slot:label)
                span {{ labelName }}
                span.red--text *
        div(v-if="isShowField")
          slot(name="full_name" :master-data="masterData")
            validation-provider(v-if="!hideFields.includes('full_name')" :rules="{required: true}" v-slot="{ errors }" :name="$t('common.full_name')")
              v-text-field#full_name(
                v-next-focus
                :error-messages="errors"
                v-model="masterData.full_name"
                :disabled="isDisabled"
              )
                template(v-slot:label)
                  span {{$t('common.full_name')}}
                  span.red--text *
          slot(name="middle" :isDisabled="isDisabled")
          slot(name="middle1" :isDisabled="isDisabled")
          slot(name="middle2" :isDisabled="isDisabled")
          v-text-field#keyword(
            v-if="!hideFields.includes('keyword')" 
            v-next-focus
            ref="keyword" :label="$t('common.keyword')" 
            v-model="masterData.keyword"
            :disabled="isDisabled"
          )
        div
          slot(name="bottom")
  
  </template>
<script>
import { defineComponent, getCurrentInstance, toRefs, ref, computed } from 'vue'
import JDialogContainer from '../JDialogContainer/index.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { normalizeString, normalizeCode } from '@/utils/string'

const JMasterDialog = defineComponent({
  components: {
    JDialogContainer,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    show: { type: Boolean, required: true },
    masterData: { type: Object, required: true },
    isAdd: { type: Boolean, required: false, default: true },
    loading: { type: Boolean, required: false, default: false },
    label: { type: String, required: false, default: '' },
    labelName: { type: String, required: false, default: '' },
    isShowField: { type: Boolean, required: false, default: true },
    isOnMobile: { type: Boolean, required: false, default: false },
    hideFields: { default: () => [] },
    type: { type: String, required: false, default: '' },
    height: { type: String, default: null },
    masterUrl: { type: String, default: '' },
    isAutofocus: { type: Boolean, required: false, default: true },
    width: { type: Number, required: false },
    readOnly: {
      type: Boolean,
      default: false
    },
    isMaster: {
      type: Boolean,
      default: false
    },
    keepOriginalValueFields: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const { masterData } = toRefs(props)
    const instance = getCurrentInstance()
    const { $refs, $toast, $root } = instance.proxy
    const test = ref(null)

    const isDisabled = computed(() => {
      return !(!props.readOnly || !props.isMaster)
    })

    // code入力時にスペースを自動削除
    const onCodeInput = (value) => {
      masterData.value.code = normalizeCode(value)
    }

    const validateElement = async () => {
      const validate = await $refs.observer.validate()
      if (!validate) {
        $toast.error($root.$t('message.check_data_type'))
        return false
      }
      return true
    }

    const resetValidate = async () => {
      const validateName = await $refs.observer
      validateName.reset()
    }

    const closeDialog = () => {
      emit('on-close')
      resetValidate()
    }

    const convertData = () => {
      const fields = Object.keys(masterData.value).filter(
        (i) => !props.keepOriginalValueFields.includes(i)
      )
      fields.forEach((key) => {
        const value = masterData.value[key]
        if (typeof value === 'string') {
          masterData.value[key] = normalizeString(value)
        } else if (value === '') {
          masterData.value[key] = null
        }
      })
    }

    const createGroup = async () => {
      convertData()
      if (await validateElement()) {
        emit('on-create')
        await resetValidate()
      }
    }

    const updateGroup = async () => {
      convertData()
      if (await validateElement()) {
        emit('on-update')
        await resetValidate()
      }
    }

    return {
      test,
      closeDialog,
      updateGroup,
      createGroup,
      isDisabled,
      onCodeInput
    }
  }
})

export default JMasterDialog
</script>
